<p-card header="Incident Report">

  @if (tokenExpired()) {
    <div >
      <p-message severity="error" text="The link you have used is expired.  You'll need to get a new link from Praying Pelican Missions to fill out this report.">
      </p-message>
    </div>
  }
  @let report = incidentReport();
  @if (report && !reportComplete() && !tokenExpired()) {
    <div>
      @if (!submissionComplete()) {
        <div>
          <app-dynamic-form [formFields]="formFields" [formData]="formData" [formKey]="getFormKey(report)" (submit)="createReport($event)" [disableSubmit]="submittingReport()" ></app-dynamic-form>
          @if (submitError()) {
            <div class="container mt-2">
              <div class="alert alert-danger" role="alert">
                <strong>There was a problem submitting your report.</strong>
                <br>
                  <br>
                    @if (!showErrDetails()) {
                      <button type="button" class="btn btn-link" (click)="showErrorDetails()">Technical Details</button>
                    }
                    @if (showErrDetails()) {
                      <div>
                        <button *ngxClipboardIfSupported ngxClipboard [cbContent]="submitError()" (cbOnSuccess)="onErrorCopied()" class="btn btn-outline-secondary">Copy Details</button>
                        @if (errorCopied()) {
                          <span class="ms-1">Details copied to clipboard!</span>
                        }
                        <pre class="json-display">{{submitError()}}</pre>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          }
          @if (submissionComplete()) {
            <div>
              <p-message severity="success">
                Submission Complete!  You may safely close this browser.
              </p-message>
            </div>
          }
        </div>
      }
      @if (reportComplete()) {
        <div>
          <p-message severity="error">
            This report has already been completed
          </p-message>
        </div>
      }

    </p-card>
